import {useEffect, useState} from "react";
import tableCalc from "../../../utils/tableCalc";
import NewTabulator from "../../NewTabulator/NewTabulator";
import _axios from "../../../httpService";

const SMSTable = () => {


const [tableData,setTableData] = useState([
  {
    title:"من عنوانم در تکرار",
    smsText : "hi dear i think im in love with you",
    sentMessageCount:25,
    UnSentMessageCount:55,
    status:"فعال",
  },
  {
    title:"title about love",
    smsText : " i adore you",
    sentMessageCount:88,
    UnSentMessageCount:12,
    status:"غیر فعال",
  }
])

  const tableColumns = [


    {
      title: "عنوان",
      field: "title",
      visible: true,
      style: {
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    {
      title: "متن",
      field: "smsText",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "تعداد ارسال موفق",
      field: "sentMessageCount",
      style: {
        minWidth: 200,
        width: 200,
        maxWidth: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "تعداد ارسال ناموفق",
      field: "UnSentMessageCount",
      visible: true,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "وضعیت",
      field: "status",
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "ویرایش",
      formatter: (cell)=>{

        return <span>
          <i className="fa fa-edit"></i>
        </span>

      }, // width: 60,
      cellClick : (e,cell)=>{
        console.log(e)
        console.log(cell)
      },
      style: {
        minWidth: 50,
        width: 50,
        maxWidth: 50,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "فعالسازی",
      formatter: "checkBox", // width: 60,
      style: {
        minWidth: 50,
        width: 50,
        maxWidth: 50,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },


      cellEdited: function (e, cell) {
        // const value = parseToEnRemoveComma(e.target.value)
        // مقدار منحصر به فرد هر سطر داره بر اساس ترکیب انبار و کدمحصول گرفته میشه
        // myCustomCelEditFunction(sendData, setSendData, cell, "number", value)
        // setReload(!reload)


      },


    },
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'center',
      },
      justifyContent: 'center',
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        console.log("حذف حذف حذف");

      },
    },


  ];
  useEffect(() => {
    _axios.get('https://jsonplaceholder.typicode.com/posts/50').then(res => {



    })

  }, [])

  return (
    <div className="sms-big-box sms-table">

      <NewTabulator
        columns={tableColumns}
        data={tableData}
        // style={{height: "50vh", overflow: 'scroll'}}
        className={"header__color__F1F1F1"}
      />


    </div>
  );
};

export default SMSTable;
